import { ListItemIcon } from "@material-ui/core";
import React, { ComponentType, FC } from "react";
import { useLocation } from "Hooks/useRouter";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import { matchPath } from "react-router";
import { Props as NavItemChildProps } from "Components/Navigation/SideNav/NavItem/NavItemChild/NavItemChild";
import { NavListItem } from "../NavListItem/NavListItem";
import { NavListItemText } from "../NavListItem/NavListItemText/NavListItemText";
import useStyles from "./styles";

export interface Props extends NavItemChildProps {
  kind: "solo";
  Icon: ComponentType;
}

const NavItemSingle: FC<Props> = ({ to, label, exact, Icon }) => {
  const { pathname } = useLocation();
  const classes = useStyles();

  const selected = !!matchPath<boolean>(pathname, { path: to, exact });

  const listItemTree = (
    <NavListItem button selected={selected}>
      <ListItemIcon className={classes.icon}>
        <Icon />
      </ListItemIcon>
      <NavListItemText
        classes={{
          primary: selected ? classes.selectedText : classes.notSelected,
        }}
        primary={label}
      />
    </NavListItem>
  );

  const isExternalLink = to.startsWith("http") || to.startsWith("tel:");

  return isExternalLink ? (
    <Link href={to} underline='none'>
      {listItemTree}
    </Link>
  ) : (
    <Link to={to} component={RouterLink} underline='none'>
      {listItemTree}
    </Link>
  );
};

export default NavItemSingle;
